import React, { useEffect, useState } from 'react'
import Layout from '../../components/Layout/Layout'
import { useNavigate, useParams } from 'react-router-dom';
import { API_ENDPOINT, API_URL_2 } from '../../api/constant';
import { callApi } from '../../api/callApi';
import { IOrder } from '../../interfaces/order';
import Table from '../../components/UI/CommonTable/CommonTable';
import Pagination from '../../components/UI/List/Pagination';
import { formatDateTime } from '../../utility/helper';
import { IAddress } from '../../interfaces/address';
import moment from '../../utility/moment-timezone';

const UserDetails: React.FC = () => {
    const [user, setuser] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [orders, setOrders] = useState<IOrder[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const { id } = useParams();
    const navigate = useNavigate()
    useEffect(() => {
        getUserDetails()
        getOrders()
    }, []);

    const getUserDetails = async () => {
        try {
            const response = await callApi(
                `${API_URL_2}${API_ENDPOINT.auth}user/detail-admin/${id}`,
                { method: "GET" }
            );
            setuser(response);
        } catch (error: any) {
            console.error("Failed to fetch user details:", error.message);
        }
    }


    async function getOrders(page: number = 1) {
        setLoading(true)
        try {
            const response = await callApi(
                `${API_URL_2}${API_ENDPOINT.order}orders?page=${page}&sortType=DESC&userId=${id}`,
                { method: "GET" }
            );
            const { currentPage, data, totalPages } = response;
            setOrders(data);
            setCurrentPage(currentPage);
            setTotalPages(totalPages);
        } catch (error: any) {
            console.error("Failed to fetch orders:", error.message);
        } finally {
            setLoading(false)
        }
    }


    const columns = [
        { header: "Order ID", accessor: "orderId" },
        {
            header: "Status", accessor: "status",
        },
        { header: 'Delivery Time', accessor: 'deliveryTime', render: (deliveryTime: string) => formatDateTime(deliveryTime) },
        { header: "Total", accessor: "total" },
        { header: "Discount", accessor: "discountedValue" },
        { header: "Grand Total", accessor: "grandTotal" },
        {
            header: "Delivery Address", accessor: "address", render: (address: IAddress) => {
                const addressLine = [
                    address.buildingName,
                    address.aptNumber,
                    address.floor,
                    address.street,
                    address.block,
                    address.additionalDirection,
                    address.phone,
                ]
                    .filter((item) => item && item.trim() !== "") // Exclude empty or null fields
                    .join(", ");
                return addressLine
            }
        },
        { header: "Created At", accessor: "createdAt", render: (createdAt: string) => moment(createdAt).format("DD MMM, YYYY hh:mm a") },
    ];

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
        getOrders(page)
    };

    const actions = [
        {
            icon: "bi bi-eye",
            color: "success",
            onClick: (order: IOrder) => navigate(`/order-details/${order.id}`),
            tooltip: 'View Order'
        },
    ];

    return (
        <Layout>
            <div className="container my-4">
                <div className="card mb-4">
                    <div className="card-header">User Details</div>
                    <div className="card-body">
                        <div className="row align-items-center">
                            {/* Profile Photo */}
                            <div className="col-md-3 text-center">
                                <img
                                    src={user?.users?.profilePhoto}
                                    alt={user?.fullName}
                                    className="img-fluid rounded"
                                    style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                                />
                            </div>
                            {/* user Info */}
                            <div className="col-md-9">
                                <h3>{user?.fullName}</h3>
                                <p><strong>Email:</strong> {user?.email}</p>
                                <p><strong>Phone:</strong> {user?.phone}</p>
                                <p>
                                    <strong>Verified:</strong> {user?.isVerified ? 'Yes' : 'No'} |{' '}
                                    <strong>Phone Verified:</strong> {user?.isPhoneVerified ? 'Yes' : 'No'}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div className="app-card app-card-orders-table shadow-sm mb-4 p-4">
                <div className="app-card-body">
                    <Table
                        columns={columns}
                        data={orders}
                        loading={loading}
                        actions={actions}
                        emptyMessage="No Orders available."
                    />
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                </div>
            </div>
        </Layout >
    )
}

export default UserDetails